export default "__VITE_ASSET__6996e41a__"